import { playerPool } from './physx-pool'

WL.registerComponent("peer-networked-player", {
}, {
  init: function() {
    this.shotRecievers = {};
    let children = this.object.children;
    for (let c of children) {
        // c.resetTranslationRotation();
        // c.rotateAxisAngleDegObject([0, 0, 1], -90);
      if(c.name === "PhysicsHead") {
        this.head = c;
        this.headMesh = c.getComponent('mesh', 0) || c.children[0].getComponent('mesh', 0);
        this.headMeshMaterial = this.headMesh.material;
        this.shotRecievers['head'] = c.getComponent('physx-shot-receiver');
      } else if(c.name === "PhysicsLeftHand") {
        this.leftHand = c;
        // this.leftHandMesh = c.getComponent('mesh', 0) || c.children[0].getComponent('mesh', 0);
        // this.leftHandMeshMaterial = this.leftHandMesh.material;
        this.shotRecievers['leftHand'] = c.getComponent('physx-shot-receiver');
      } else if(c.name === "PhysicsRightHand") {
        this.rightHand = c;
        // this.rightHandMesh = c.getComponent('mesh', 0) || c.children[0].getComponent('mesh', 0);
        // this.rightHandMeshMaterial = this.rightHandMesh.material;
        this.shotRecievers['rightHand'] = c.getComponent('physx-shot-receiver');
      } else if (c.name === "PhysicsBody") {
        this.body = c;
        // c.rotateAxisAngleDegObject([0, 0, 1], 90);
        this.bodyMesh = c.getComponent('mesh', 0) || c.children[0].getComponent('mesh', 0);
        this.bodyMeshMaterial = this.bodyMesh.material;
        this.shotRecievers['body'] = c.getComponent('physx-shot-receiver');
      }
    }
    this.object.setTranslationLocal([0,-8,0]);
  },
  setName: function(name, nameTagMaterial, cameraObject) {
    this.playerText = WL.scene.addObject(1);
    this.playerText.name = `NameTag ${name}`;
    this.playerText.addComponent('text', {
        text: name,
        material: nameTagMaterial,
        alignment: WL.Alignment.Center
    });
    this.playerText.addComponent('player-name-display', {
        positionParent: this.head,
        positionYOffset: 1,
        target: cameraObject,
    });
    this.playerText.scale([4,4,4])
    this.name = name;
  },
  reset: function() {
    this.head.resetTranslationRotation();
    this.rightHand.resetTranslationRotation();
    this.leftHand.resetTranslationRotation();
  },
  setTransforms: function(transforms) {
    this.head.transformLocal.set(new Float32Array(transforms.head));
    this.head.setDirty();

    this.rightHand.transformLocal.set(new Float32Array(transforms.rightHand));
    this.rightHand.setDirty();

    this.leftHand.transformLocal.set(new Float32Array(transforms.leftHand));
    this.leftHand.setDirty();
  },
  updateTransform: function(object, value, idx) {
    const obj = object;
    const t = [...this[obj].transformLocal];
    t[idx] = value;
    this[obj].transformLocal.set(t);
    this[obj].setDirty();
  },
  activate: function(name, hitRelayer) {
    // TODO: every object at the end should have one mesh component. If the final does not, adapt this.
    // this.head.getComponent('mesh').active = true;
    // this.head.getComponent('physx').active = true;
    // this.rightHand.getComponent('mesh').active = true;
    // this.rightHand.getComponent('physx').active = true;
    // this.leftHand.getComponent('mesh').active = true;
    // this.leftHand.getComponent('physx').active = true;
    // this.body.getComponent('mesh').active = true;
    // this.body.getComponent('physx').active = true;

    for (const key in this.shotRecievers) {
      this.shotRecievers[key].addCallback(() => {
        hitRelayer.sendShot(`${name}|${key}`);
      })
    }
  },
  remove: function() {
    // TODO: every object at the end should have one mesh component. If the final does not, adapt this.
    // this.head.getComponent('mesh').active = false;
    // this.head.getComponent('physx').active = false;
    // this.rightHand.getComponent('mesh').active = false;
    // this.rightHand.getComponent('physx').active = false;
    // this.leftHand.getComponent('mesh').active = false;
    // this.leftHand.getComponent('physx').active = false;
    // this.body.getComponent('mesh').active = false;
    // this.body.getComponent('physx').active = false;

    playerPool.returnEntity(this.object);

    for (const key in this.shotRecievers) {
      this.shotRecievers[key].removeAllCallbacks();
    }

    if(this.playerText) this.playerText.destroy();
  },
  applyMaterial: function(mat) {
    if(!this.headMesh || !this.bodyMesh) return;
    this.headMesh.material = mat;
    // this.leftHandMesh.material = mat;
    // this.rightHandMesh.material = mat;
    this.bodyMesh.material = mat;
  },
  resetMaterial: function() {
    if(!this.headMesh || !this.bodyMesh) return;
    this.headMesh.material = this.headMeshMaterial;
    // this.leftHandMesh.material = this.leftHandMaterial;
    // this.rightHandMesh.material = this.rightHandMaterial;
    this.bodyMesh.material = this.bodyMeshMaterial;
  }
});

WL.registerComponent("peer-networked-player-spawner", {
  nameTagMaterial: {type: WL.Type.Material},
  cameraObject: {type: WL.Type.Object},
}, {
  init: function() {
    this.count = 0;
  },
  start: function() {
    this.hitRelayer = this.object.getComponent('hit-relayer');
  },

  getEntity: function(name) {
    const player = playerPool.getEntity();
    //TODO: Should use pooling instead of creation for text

    // Offset based on player offset in the scene
    // playerOffset.translateObject([0, 2, 0]);

    // bodyCol.rotateAxisAngleDegObject([0, 0, 1], 90);

    player.resetTranslation();
    
    const playerNetworkComponent = player.getComponent("peer-networked-player")
    playerNetworkComponent.setName(name, this.nameTagMaterial, this.cameraObject);
    playerNetworkComponent.activate(name, this.hitRelayer);
    return playerNetworkComponent;
  },
  
  returnEntity: function(player) {
    player.getComponent("peer-networked-player").remove();
    player.setTranslationLocal([0,-8,0]);
    // player.children[0].children.forEach((c) => { c.active = false; });
    // player.active = false;
  },
});

WL.registerComponent("hit-relayer", {
  gunObj: { type: WL.Type.Object }
}, {
  start: function () {
    this.gun = this.gunObj.getComponent('gun');
  },
  sendShot: function(target) {
    // this.gun.shoot(target);
  }
});
